// This component displays a list showing each station's menu.

import { Text } from "@fluentui/react";
import React from "react";
import styles from "../../styles/menuPreview.module.css";
import StationCard from "./StationCard";
import { PreviewMenu } from "./types/menuPreviewTypes";

export interface MenuSectionProps {
  previewMenuList: PreviewMenu[] | undefined;
}

const MenuSection = ({ previewMenuList }: MenuSectionProps) => (
  <ul className={styles.menuSection}>
    {previewMenuList ? (
      previewMenuList.map((previewMenu: PreviewMenu) => (
        <StationCard previewMenu={previewMenu} key={previewMenu.stationId} />
      ))
    ) : (
      <Text>No menu data for this day.</Text>
    )}
  </ul>
);

export default MenuSection;
